import Title2 from "./title2";
import MainLocation from "./mainLocation";

export default function Location() {
  return (
    <div>
      <Title2 title="Location" />
      <MainLocation  />
    </div>
  );
}
